module.exports = __webpack_public_path__ + "static/img/hb_24-min.937bd02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_24-min.png
// module id = uQdM
// module chunks = 1